/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var receivablesCertainPeriodColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px'
}, {
  name: 'Кр. номер',
  render: function render(data) {
    return ___EmotionJSX(Link, {
      "data-value": "data.number",
      to: "credits/details/".concat(data === null || data === void 0 ? void 0 : data.id)
    }, data.number);
  },
  width: '110px'
}, {
  name: 'Кредитоиск.',
  value: 'borrower_name',
  width: '110px'
}, {
  name: 'Събр. Главници',
  render: function render(_ref) {
    var total_payed_principal = _ref.total_payed_principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_principal"
    }, total_payed_principal, " ", currency);
  }
}, {
  name: 'Събр. Лихви',
  render: function render(_ref2) {
    var total_payed_interest = _ref2.total_payed_interest,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_interest"
    }, total_payed_interest, " ", currency);
  }
}, {
  name: 'Общо събр. сума',
  render: function render(_ref3) {
    var total_payed_amount = _ref3.total_payed_amount,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_amount"
    }, total_payed_amount, " ", currency);
  }
}];